<template>
    <v-text-field
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
        variant="outlined"
        density="compact"
        type="text"
    />
</template>

<script>
export default {
    props: ["modelValue"],

    emits: ["update:modelValue"],

    methods: {
        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>
